import { BasicModel } from './basic.model';

export class MediaLineModel {
  constructor(
    public id: number = null,
    public selected: any = new BasicModel(),
    public included: BasicModel[] = [],
    public excluded: BasicModel[] = []
  ) {}

  public fromJSON(json) {
    for (let propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
